/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagKeyValueRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("TagKeyValueRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return TagKeyValueRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<TagKeyValueRegexQueryOperator>): TagKeyValueRegexQueryOperator {
        let obj = Object.assign(new TagKeyValueRegexQueryOperator(), model);
        TagKeyValueRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagKeyValueRegexQueryOperator>): TagKeyValueRegexQueryOperator {
        if (!model) return null;
        return TagKeyValueRegexQueryOperator.newInstance(<TagKeyValueRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagKeyValueRegexQueryOperator) {
        if (!obj) return;

        models.TagKeyValueRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagKeyValueRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagKeyValueRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.tag_key) {
            models.Regex.fixupPrototype(this.tag_key);
        }
        if (this.tag_value) {
            models.Regex.fixupPrototype(this.tag_value);
        }
    }

    /**
     * Tag key pattern to identify and include corresponding response
     */
    tag_key: models.Regex;

    /**
     * Tag value pattern to identify and include corresponding response
     */
    tag_value: models.Regex;

    /**
     * Tag kind if applicable
     */
    tag_kind: string;

}
